import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom'
import React, {useRef, useState, useEffect} from 'react';
import ScrollToTop from "@/components/ScrollToTop";
import logoFooterPic from '@/assets/images/logo-footer-mobile.png';
import copyrightPic from '@/assets/images/copyright.png';
import arrowSignUp from '@/assets/images/arrow-signup.png';
import mobileLogoPic from '@/assets/logos/mobile-logo.png';
import menuIconPic from '@/assets/images/menu-icon.png';
import { animateScroll } from "react-scroll";
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';

function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const footerRef = useRef<HTMLElement>(null);
  // const [aboutClicked, setAboutClicked] = useState(false);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [currentPath, setCurrentPath] = useState(location.pathname);
  const [isSubscribing, setIsSubscribing] = useState(false);
  const [isBlur, setIsBlur] = React.useState(true);
  // 控制菜单蒙版显示的状态
  const [isMenuOverlayVisible, setIsMenuOverlayVisible] = useState(false);

  // 监听蒙版显示状态变化，控制body滚动
  useEffect(() => {
    if (isMenuOverlayVisible) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    // 组件卸载时恢复body滚动
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMenuOverlayVisible]);

  // 导航项配置
  const navItems = [
    { id: 'investment-solutions', offset: 0, path: '/?section=investment-solutions', label: 'Investment Solutions' },
    { id: 'polaris-20-fund', offset:0, path: '/?section=polaris-20-fund', label: 'Polaris 20 Fund', hidden: true },
    { id: 'polaris-co-invest', offset:0, path: '/?section=polaris-co-invest', label: 'Polaris Co-Invest', hidden: true },
    { id: 'data-research', offset:0, path: '/?section=data-research', label: 'Data & Research', hidden: true },
    { id: 'why-private-tech', offset:0, path: '/?section=why-private-tech', label: 'Why Private Tech' },
    { id: 'data-research-portal', offset:0, path: '/?section=data-research-portal', label: 'Data & Research Portal' },
    { id: 'about', offset:0, path: '/?section=about', label: 'About' }
  ];

  // 滚动到footer的函数
  // const scrollToFooter = () => {
  //   if (footerRef.current) {
  //     setAboutClicked(true);
  //     footerRef.current.scrollIntoView({
  //       behavior: 'smooth',
  //       block: 'start'
  //     });
  //     // 2秒后重置点击状态
  //     setTimeout(() => setAboutClicked(false), 2000);
  //   }
  // };

  // 在hash路由模式下获取实际路径（如从/#/signup中获取/signup）
  // 注意：在createHashRouter中，useLocation().pathname已经会返回正确的路径
  // 例如，对于URL #/signup，pathname会是 "/signup"
  // const getCurrentRoutePath = () => {
  //   return location.pathname;
  // };

  // 监听路由变化
  useEffect(() => {
    // 当路由变化时，关闭菜单蒙版
    setIsMenuOverlayVisible(false);

    if (location.pathname !== currentPath) {
      setIsTransitioning(true);
      // 先让当前页面消失
      setTimeout(() => {
        setCurrentPath(location.pathname);
        // 再让新页面出现
        setTimeout(() => {
          setIsTransitioning(false);
        }, 150);
      }, 600);
    }
  }, [location.pathname, currentPath]);

  // 添加防抖状态
  const [isScrolling, setIsScrolling] = useState(false);
  const [canAutoScroll, setCanAutoScroll] = useState(false);
  const [currentSection, setCurrentSection] = useState('investment-solutions');

  // 监听路由查询参数，处理section滚动
  useEffect(() => {
    // 如果动画正在执行，则不再次触发
    if (isScrolling) {
      return;
    }
    if(!canAutoScroll) {
      return
    }

    // 只在根路径下处理section参数
    if (location.pathname === '/') {
      const searchParams = new URLSearchParams(location.search);
      const section = searchParams.get('section');

      if (section) {
        // 在navItems中查找匹配的section
        const navItem = navItems.find(item => item.id === section);

        if (navItem) {
          if(!navItem.hidden) {
            setCurrentSection(section)
          } else {
            // 非导航栏项目，要单独设置canAutoScroll
            setCanAutoScroll(true);
          }
          scrollToSection(section)
        }
      }
    }
  }, [location.search, location.pathname, currentSection, navItems, isScrolling, canAutoScroll]);

  const scrollToSection = (section: string) => {
    // 确保DOM已经渲染完成
    setTimeout(() => {
      const element = document.getElementById(section);
      if (element) {
        // 设置防抖状态为true，表示动画开始
        setIsScrolling(true);

        // 计算滚动目标位置，考虑navItem的offset
        const scrollTarget = element.offsetTop - (section==='data-research-portal' ? 22 : 0);

        animateScroll.scrollTo(scrollTarget, {
          duration: 1000,
          ease: 'easeInOut',
          smooth: true,
          offset: 0
        });

        // 动画结束后重置防抖状态
        setTimeout(() => {
          setIsScrolling(false);
          setCanAutoScroll(false);
        }, 1000);
      }
    }, 0);
  }
  useEffect(() => {
    if(location.pathname!=='/'){
      setCurrentSection('')
    }
  }, [location.pathname]);
  // 处理导航点击
  const handleNavigation = (section: string) => {
    setIsMenuOverlayVisible(false);
    setCanAutoScroll(true);
    setCurrentSection(section);
    setTimeout(() => {
      navigate(`/?section=${section}`);
    }, 0)
    // 双重保护，页面内直接滚动到对应section
    scrollToSection(section);
  };

  useEffect(() => {
    document.querySelectorAll('.scrollable-link').forEach((_)=>{
      _.addEventListener('click', ()=>{
        setCanAutoScroll(true)
      });
    })
  }, []);

  // 判断是否为当前路径
  const isActive = (id: string, section: string) => {
    // 只有在首页才有可能被选中
    return location.pathname==='/' && id === section;
  };

  // 获取导航项的样式类
  const getNavItemClass = (id:string, section: string) => {
    const baseClass = "py-2 text-base font-medium font-['Figtree'] tracking-tight relative cursor-pointer";
    const hoverClass = "hover:text-[#6E66E1]"
    const activeClass = isActive(id, section)
      ? "text-[#6E66E1]"
      : "text-[#414141]";
    return `${baseClass} ${activeClass} ${hoverClass}`;
  };

  // Throttle function for performance optimization
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  function throttle(func, wait) {
    let timeout:NodeJS.Timeout;
    return function executedFunction(...args: never[]) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
  const updateActiveNavLink = ()=> {
    const sections = document.querySelectorAll('section[id],footer[id]');

    let curSection = '';

    sections.forEach(section => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      const sectionTop = section.offsetTop - 106;
      const sectionHeight = section.clientHeight;

      if (window.scrollY >= sectionTop && window.scrollY < sectionTop + sectionHeight) {
        curSection = section.getAttribute('id')||'';
        setCurrentSection(curSection);
      }
    });
  }

  const optimizedScrollHandler = throttle(function() {
    updateActiveNavLink();
  }, 100);

  window.addEventListener('scroll', optimizedScrollHandler, false);

  const submitForm = (e)=>{
    setIsBlur(false)
    const form = document.getElementById('emailForm') as HTMLFormElement
    if (!form.checkValidity()) {
      form.reportValidity();
      setTimeout(() => {
        setIsBlur(true)
      }, 100)
    } else {
      subscribe()
    }
  }
  const subscribe = async ()=>{
    const emailInput = document.getElementById('emailInput') as HTMLInputElement;
    const email = emailInput.value.trim();
    setIsSubscribing(true)
    const response = await axios.post(`${import.meta.env.VITE_APP_API_BASE_URL}/polaris-api/subscribe?email=${encodeURIComponent(email)}`);
    setIsSubscribing(false)

    if (response.data) {
      const { result } = response.data;
      if(result) {
        toast.success('Subscribe successfully.', {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        emailInput.value=''
      }
    }
  }
  return (
    <div className="min-h-screen bg-white">
      <ScrollToTop/>
      <ToastContainer />
      {/* 顶部导航栏 */}
      <nav className={`fixed top-0 left-0 right-0 z-50 bg-white/60 backdrop-blur-xl border-b border-gray-200/30 shadow-sm animate-in slide-in-from-top-2 duration-500`}>
        <div className="h-[52px] mx-auto py-2 px-[10px]">
          <div className="flex justify-between items-center h-9">
            <div className="flex items-center">
               <Link to={'/'} className="flex items-center cursor-pointer group relative">
                 <img
                   src={mobileLogoPic}
                   alt="Sign Up"
                   className="object-cover"
                 />
               </Link>
            </div>
            {/* 暂时隐藏Sign Up，flex->display-none */}
            <div className="display-none items-center gap-5">
              <div className="flex items-center space-x-4">
                {/* Sign Up 按钮 */}
                <Link
                    to="/signup"
                    className="relative bg-gradient-to-r from-[#6E66E1] via-[#4D47A9] to-[#3C387B] border-[#5147E5] text-white px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 ease-in-out shadow-sm cursor-pointer hover:shadow-[2px_0px_11.300000190734863px_0px_rgba(110,102,225,1.00)] overflow-hidden"
                    onMouseMove={(e) => {
                      const rect = e.currentTarget.getBoundingClientRect();
                      const x = e.clientX - rect.left;
                      const percentage = (x / rect.width) * 100;
                      const leftMiddlePercentage = percentage / 2;
                      const rightMiddlePercentage = percentage + (100 - percentage) / 2;
                      e.currentTarget.style.setProperty('--mouse-position', `${percentage}%`);
                      e.currentTarget.style.setProperty('--left-middle', `${leftMiddlePercentage}%`);
                      e.currentTarget.style.setProperty('--right-middle', `${rightMiddlePercentage}%`);
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.removeProperty('--mouse-position');
                      e.currentTarget.style.removeProperty('--left-middle');
                      e.currentTarget.style.removeProperty('--right-middle');
                    }}
                    style={{
                      '--mouse-position': '0%',
                      '--left-middle': '0%',
                      '--right-middle': '0%'
                    }}
                  >
                    <span className="relative text-xs font-light z-10 flex items-center pointer-events-none">
                      Sign Up
                      <div className="w-3 h-3 ml-2 mr-1 inline-block relative top-0.5" >
                        <img
                          src={arrowSignUp}
                          alt="Sign Up"
                          className="object-cover"
                        />
                      </div>
                    </span>
                    {/* 基于鼠标位置的多色渐变 */}
                    <span className="absolute inset-0 opacity-0 hover:opacity-100 transition-opacity duration-300 rounded-full"
                      style={{
                        backgroundImage: `linear-gradient(to right, #3C387B 0%, #4D47A9 var(--left-middle), #6E66E1 var(--mouse-position), #4D47A9 var(--right-middle), #3C387B 100%)`
                      }}></span>
                </Link>
              </div>
              <div
                className="flex w-6 h-6 justify-center items-center cursor-pointer z-50"
                onClick={() => setIsMenuOverlayVisible(!isMenuOverlayVisible)}
              >
                <img
                  src={menuIconPic}
                  alt="Menu"
                  className="object-cover"
                />
              </div>
            </div>
            </div>
          </div>
        </nav>

      {/* 菜单蒙版 - 从header nav下方到页面最底部的半透明白色蒙版 */}
      {isMenuOverlayVisible && (
        <div
          className="fixed top-[53px] left-0 right-0 bottom-0 bg-white/90 backdrop-blur-sm z-40 transition-opacity duration-300 ease-in-out"
        >
          <div
            className="max-w-[1440px] mx-auto px-6 pt-5 pb-2 h-full flex flex-col"
          >
            {/* 首页菜单 */}
            <div className="flex-1 overflow-y-auto">
              <div className="flex flex-col justify-center items-baseline mb-10">
                {navItems.map((item) => {
                  // 其他菜单项使用路由跳转
                  return (
                    <div
                      key={item.id}
                      className={getNavItemClass(item.id, currentSection)}
                      onClick={()=>handleNavigation(item.id)}
                    >
                      {/* 文字内容 */}
                      <span className="relative z-10 text-sm">{item.label}</span>
                      <svg className={`inline-block ml-1 relative top-0`} width="8" height="8" viewBox="0 0 11 11" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.718546 9.60006L9.28273 1.03587L1.942 1.03587L1.87908 0.0501194L10.9676 0.0501197L10.9676 9.13864L9.98185 9.07572L9.98185 1.73499L1.41766 10.2992L0.718546 9.60006Z" strokeWidth="0.25" fill="currentColor" stroke="currentColor"/>
                      </svg>
                    </div>
                  );
                })}
              </div>
              <div className="grid grid-cols-2 gap-y-10 gap-x-1 text-sm text-[#2B2B2B]">
                <div>
                  <div className="text-[#6E66E1] text-xs font-medium font-['Figtree'] mb-3">Who We Serve</div>
                  <ul className="space-y-3 text-[#121212CC] text-base font-medium font-['Figtree'] leading-none">
                    <li>Private Wealth</li>
                    <li>Family Office</li>
                    <li>Institutional Investors</li>
                    <li>Asia Private Investors</li>
                  </ul>
                </div>
                <div className="pl-5">
                  <div className="text-[#6E66E1] text-xs font-medium font-['Figtree'] mb-3">Products</div>
                  <ul className="space-y-3 text-[#121212CC] text-base font-medium font-['Figtree'] leading-none">
                    <li>Market Data</li>
                    <li>Polaris 20</li>
                    <li>Polaris Invest</li>
                  </ul>
                </div>
                <div>
                  <div className="text-[#6E66E1] text-xs font-medium font-['Figtree'] mb-3">Resources</div>
                  <ul className="space-y-3 text-[#121212CC] text-base font-medium font-['Figtree'] leading-none">
                    <li>Blog</li>
                    <li>Events</li>
                    <li>Documentation</li>
                    <li>APIs</li>
                  </ul>
                </div>
                <div className="pl-5">
                  <div className="text-[#6E66E1] text-xs font-medium font-['Figtree'] mb-3">About Us</div>
                  <ul className="space-y-3 text-[#121212CC] text-base font-medium font-['Figtree'] leading-none">
                    <li>Our Company</li>
                    <li>Contact Us</li>
                  </ul>
                </div>
                <div className="col-span-2">
                  <div className="text-[#6E66E1] text-xs font-medium font-['Figtree'] mb-3">Contact Us</div>
                  <ul className="space-y-2 text-[#121212CC] text-base font-medium font-['Figtree']">
                    <li><a href="mailto:operation@polariscapitalai.com">operation@polariscapitalai.com</a></li>
                  </ul>
                </div>
              </div>
            </div>

            {/* 版权与底栏 - 固定在底部 */}
            <div className="mt-2 pt-0 pb-1 flex flex-col md:flex-row items-center justify-between text-sm text-[#121212CC]">
              <div className="w-full flex flex-row justify-between space-x-12">
                <span className="text-[#3E3E3E] text-xs font-normal font-['Figtree']"><Link to={`/terms-of-use`} target={`_blank`}>Terms of use</Link></span>
                <span className="text-[#3E3E3E] text-xs font-normal font-['Figtree']"><Link to={`/privacy-policy`} target={`_blank`}>Privacy policy</Link></span>
                <span className="text-[#3E3E3E] text-xs font-normal font-['Figtree']"><Link to={`/disclaimer`} target={`_blank`}>Disclaimer</Link></span>
              </div>
            </div>
            <div className="mt-0.5 pt-2.5 border-t border-[#12121233] flex flex-col md:flex-row items-center justify-between text-sm text-[#121212CC]">
              <div className="flex items-center space-x-1 mb-4 md:mb-0 ">
                <div className="w-5 h-5 rounded-full text-sm flex items-center justify-center">
                  <img
                    src={copyrightPic}
                    alt="Copyright"
                    className="w-5 h-5"
                  />
                </div>
                <span className="text-[#3E3E3E] text-sm font-normal font-['Figtree']">Polaris Capital 2025</span>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="mx-auto relative top-[54px]">
       {/* 子路由内容将在这里渲染 */}
       <div
         className={`transition-all duration-700 ease-in-out relative ${
           isTransitioning ? 'opacity-0 scale-95' : 'opacity-100 scale-100'
         }`}
       >
         {/* 过渡覆盖层 - 只覆盖页面内容，不影响菜单 */}
         {isTransitioning && (
           <div className="absolute inset-0 bg-white z-50 transition-opacity duration-300 ease-in-out"></div>
         )}
         <Outlet/>
       </div>
      </div>
      {/* 底部导航 - 在login、signup和contact-us页面不显示 */}
      {!['/login', '/signup', '/contact-us'].includes(location.pathname) && (
      <footer id="about" ref={footerRef} className="bg-[#F1F0F2]">
        <div className="max-w-[1440px] mx-auto px-6 sm:px-8 lg:px-10 pt-16 pb-5">
          {/* 顶部品牌与订阅 */}
          <div className="text-center mb-14">
            <div className="flex items-center justify-center mb-10">
              <img src={logoFooterPic} alt="POLARIS CAPITAL" className="object-contain w-[127px] h-[55px] mt-5" />
            </div>
            <h3 className="text-lg text-[#3E3E3E] max-w-2xl mx-auto mb-6 display-none">
              Stay ahead of the curve with exclusive updates on technology, pre‑IPO insights, portfolio highlights, and private Polaris trends—delivered straight to your inbox every Wednesday.
            </h3>
            <form id="emailForm" onSubmit={(e)=>{e.preventDefault();}} className="flex flex-col items-center justify-center gap-3 max-w-xl mx-auto">
              <input
                id="emailInput"
                type="email"
                placeholder="Email"
                className={`w-full px-5 h-11 text-[14px] text-[#424242] rounded-full bg-[#E5E4E6] border border-gray-200 focus:ring-2 focus:ring-purple-500 focus:border-purple-500 outline-none ${isSubscribing?'cursor-not-allowed':''}`}
                required
                disabled={isSubscribing}
                onKeyDown={(e) => {
                  setIsBlur(false);
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    const input = e.target as HTMLInputElement;
                    input.setCustomValidity('');
                    if (!input.checkValidity()) {
                      // input.setCustomValidity('Please enter a valid email address');
                      input.setCustomValidity('');
                    }
                    input.reportValidity();
                  } else {
                    const input = e.target as HTMLInputElement;
                    // 将验证信息设置为多个空格，可让验证信息不显示
                    input.setCustomValidity('  ');
                  }
                }}
                onBlur={(e)=>{
                  const input = e.target as HTMLInputElement;
                  // input.setCustomValidity('');
                  if(!isBlur){
                    setIsBlur(true);
                    if (!input.checkValidity()) {
                      // input.setCustomValidity('Please enter a valid email address');
                      input.setCustomValidity('');
                    }
                    // input.reportValidity();

                  }

                }}
              />
              <button disabled={isSubscribing} onClick={submitForm} type="submit" className={`w-full h-11 rounded-full bg-[#6E66E1] text-white text-sm font-bold font-['Figtree'] hover:bg-[#5c4fd6] transition-colors inline-flex items-center justify-center ${isSubscribing?'cursor-not-allowed':'cursor-pointer'}`}>
                Subscribe <svg className="w-3 h-3 ml-1 text-white transform rotate" fill="none" stroke="currentColor" strokeWidth="0.5" viewBox="0 0 12 12">
                <path d="M0.322291 10.3705L9.4982 1.19455L1.63314 1.19455L1.56572 0.138381H11.3034V9.87608L10.2473 9.80867L10.2473 1.9436L1.07134 11.1195L0.322291 10.3705Z" fill="white"/>
              </svg>
              </button>
            </form>
            <p className="mt-8 text-[10px] text-left font-normal text-[#808080] max-w-xl mx-auto leading-tight -tracking-wide">
              By subscribing, you agree to Polaris’ <Link to={`/privacy-policy`} target={`_blank`} className={`underline underline-offset-2`}>Privacy Policy</Link> and consent to the processing of your Personal Data to receive the guide and Polarising information on growth equity and pre‑IPO investments. You confirm that you have read and accepted the <Link to={`/disclaimer`} target={`_blank`} className={`underline underline-offset-2`}>Disclaimer</Link>. You may opt out at any time.
            </p>
          </div>

          {/* 链接分栏 */}
          <div className="grid grid-cols-2 gap-y-10 gap-x-1 text-sm text-[#2B2B2B]">
            <div className="col-span-2">
              <div className="text-[#6E66E1] text-xs font-medium font-['Figtree'] mb-3">Contact Us</div>
              <ul className="space-y-2 text-[#121212CC] text-base font-medium font-['Figtree']">
                <li><a href="mailto:operation@polariscapitalai.com">operation@polariscapitalai.com</a></li>
              </ul>
            </div>

            <div>
              <div className="text-[#6E66E1] text-xs font-medium font-['Figtree'] mb-3">Who We Serve</div>
              <ul className="space-y-3 text-[#121212CC] text-base font-medium font-['Figtree'] leading-none">
                <li>Private Wealth</li>
                <li>Family Office</li>
                <li>Institutional Investors</li>
                <li>Asia Private Investors</li>
              </ul>
            </div>
            <div className="pl-5">
              <div className="text-[#6E66E1] text-xs font-medium font-['Figtree'] mb-3">Products</div>
              <ul className="space-y-3 text-[#121212CC] text-base font-medium font-['Figtree'] leading-none">
                <li>Market Data</li>
                <li>Polaris 20</li>
                <li>Polaris Invest</li>
              </ul>
            </div>
            <div>
              <div className="text-[#6E66E1] text-xs font-medium font-['Figtree'] mb-3">Resources</div>
              <ul className="space-y-3 text-[#121212CC] text-base font-medium font-['Figtree'] leading-none">
                <li>Blog</li>
                <li>Events</li>
                <li>Documentation</li>
                <li>APIs</li>
              </ul>
            </div>
            <div className="pl-5">
              <div className="text-[#6E66E1] text-xs font-medium font-['Figtree'] mb-3">About Us</div>
              <ul className="space-y-3 text-[#121212CC] text-base font-medium font-['Figtree'] leading-none">
                <li>Our Company</li>
                <li>Contact Us</li>
              </ul>
            </div>
          </div>

          {/* 版权与底栏 */}
          <div className="mt-10 pt-0 flex flex-col md:flex-row items-center justify-between text-sm text-[#121212CC]">
            <div className="w-full flex flex-row justify-between space-x-12">
              <span className="text-[#3E3E3E] text-xs font-normal font-['Figtree']"><Link to={`/terms-of-use`} target={`_blank`}>Terms of use</Link></span>
              <span className="text-[#3E3E3E] text-xs font-normal font-['Figtree']"><Link to={`/privacy-policy`} target={`_blank`}>Privacy policy</Link></span>
              <span className="text-[#3E3E3E] text-xs font-normal font-['Figtree']"><Link to={`/disclaimer`} target={`_blank`}>Disclaimer</Link></span>
            </div>
          </div>
          <div className="mt-0.5 pt-2 border-t border-[#12121233] flex flex-col md:flex-row items-center justify-between text-sm text-[#121212CC]">
            <div className="flex items-center space-x-1 mb-4 md:mb-0 ">
              <div className="w-5 h-5 rounded-full text-sm flex items-center justify-center">
                <img
                  src={copyrightPic}
                  alt="Copyright"
                  className="w-5 h-5"
                />
              </div>
              <span className="text-[#3E3E3E] text-sm font-normal font-['Figtree']">Polaris Capital 2025</span>
            </div>
          </div>
        </div>
      </footer>
      )}
    </div>
  );
}

export default App;
